import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './descriptionConfiguration.module.scss';
import { CustomTextField } from '../../../shared/customTextField';
import { CustomButton } from '../../../shared/customButton';
import { CustomTextArea } from '../../../shared/customTextArea';
import * as yup from 'yup';
import { Formik } from 'formik';


const AddDescriptionConfiguration = (props) => {

    //yup validations
    const schema = yup.object({
        companyDesc: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(200, 'Character length should be less than 200').required('Required')
    });

    //on submit function
    const onSubmit = async (values) => {
        props.setCompanyDesc(values)
        props.nextPage(3)
    }


    return (
        <div>
            <Formik
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ companyDesc: props.companyDetails.description }}
                >

                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <p className={styles.bodyMainText}>Write a brief description about your company. This will be visible in public job vacancy pages.</p>
                        <CustomTextArea
                            name="companyDesc"
                            values={values.companyDesc}
                            errorMessage={errors.companyDesc}
                            handleChange={handleChange}
                            isInvalid={submitCount > 0 && !!errors.companyDesc}
                            remainingCount={(values.companyDesc).length}
                            maxLength={200}
                        />
                        <hr className={styles.dividerLine}/>
                        <div className="mt-3 mb-3 d-flex flex-row-reverse">
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="pipeline_additional_detail_confirm"
                                    buttonType="submit"
                                    label="Next"
                                    type="primaryBtn"
                                />
                            </div>
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="pipeline_additional_detail_cancel"
                                    buttonType="button"
                                    label="Back"
                                    type="defaultBtn"
                                    handleClick={() => props.previousPage(1)}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            

        </div>
    )
}

export default AddDescriptionConfiguration;
